import { useState } from "react";
import { getFormattedMonthWeekday, getFormattedTimeWithTZ } from "@/utils/date";
import useOnce from "@/utils/hooks/useOnce";

// Extracting these functions to a use effect to ensure client side rendering,
// should not be needed but this NEXTJS bug https://github.com/vercel/next.js/issues/61911
// is causing the suppressHydrationWarning to cancel hydration.  This can be reverted if the bug is ever fixed.

interface DateTimeStringProps {
  isoString: string | undefined | null;
}

export const DayWeekStringClient = ({ isoString }: DateTimeStringProps) => {
  const [dayWeekString, setDayWeekString] = useState("-");
  useOnce(() => {
    if (isoString) {
      setDayWeekString(getFormattedMonthWeekday(isoString));
    }
  });

  return dayWeekString;
};

export const TimeStringClient = ({ isoString }: DateTimeStringProps) => {
  const [timeString, setTimeString] = useState("-");
  useOnce(() => {
    if (isoString) {
      setTimeString(getFormattedTimeWithTZ(isoString));
    }
  });

  return timeString;
};
